import { render } from "./EditProfileModal.vue?vue&type=template&id=7735df26&scoped=true"
import script from "./EditProfileModal.vue?vue&type=script&lang=js"
export * from "./EditProfileModal.vue?vue&type=script&lang=js"

import "./EditProfileModal.vue?vue&type=style&index=0&id=7735df26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7735df26"]])

export default __exports__